export enum Pages {
    TRANSACTION,
    BID_HISTORY,
    DETAILS_BID
}

export enum PageTypes {
    HOMEPAGE = "homepage",
    MARKETPLACE = "marketplace",
    TRANSPORTERS = "transporters",
    GROW_NETWORK = "grow-network",
    ONLINE_LOAD_BOOKING = "online-load-booking",
    ONLINE_TRUCK_BOOKING = "online-truck-booking",
    LOGISTICS_SERVICE = "logistics-service",
    FULL_TRUCK_LOAD = "full-truck-load",
    PART_LOAD_BOOKING = "part-load-booking",
    BUSINESS_CARDS = "business-cards",
    ABOUT_US = "about-us",
    HOW_VAHAK_HELPS = "how-vahak-helps",
    WHY_CHOOSE_US = "why-choose-us",
    CAREERS = "careers",
    CONTACT_US = "contact-us",
    MY_LOADS = "my-loads",
    MY_LORRIES = "my-lorries",
    USER_PROFILE = "user-profile"
}
